<template>
  <li class="relative list-none" :class="[SMALL_ALT_ITEM_SIZE_CLASS]">
    <RevButtonBase
      :aria-current="isActive ? 'true' : undefined"
      :aria-label
      class="h-full w-full cursor-pointer"
      @click="emit('select')"
    >
      <slot name="default" />
    </RevButtonBase>
    <div
      v-if="withSticker"
      class="pointer-events-none absolute top-0 right-12 empty:hidden"
    >
      <slot name="sticker" size="small" />
    </div>
  </li>
</template>

<script setup lang="ts">
import type { VNode } from 'vue'

import { RevButtonBase } from '@ds/components/ButtonBase'

import { SMALL_ALT_ITEM_SIZE_CLASS } from './GalleryDesktopThumbnail.constants'

withDefaults(
  defineProps<{
    isActive?: boolean
    ariaLabel?: string
    withSticker?: boolean
  }>(),
  {
    isActive: false,
    ariaLabel: undefined,
    withSticker: false,
  },
)

defineSlots<{
  default?: () => VNode[]
  sticker?: (props: { size?: 'small' | 'default' }) => VNode[]
}>()

const emit = defineEmits<{
  (e: 'select'): void
}>()
</script>
